export default "__VITE_ASSET__BVt34tlt__"